import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './EditUser.module.scss';

const EditUser = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    role: '',
    permissions: '',
    color: ''
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    // Fetch the current user's role
    const fetchUserRole = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/auth/userRole`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserRole(res.data.role);

        if (res.data.role !== 'admin') {
          navigate('/unauthorized'); // Redirect if not admin
        }
      } catch (err) {
        console.error('Failed to fetch user role', err);
      }
    };

    // Fetch the user data to be edited
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(res.data);
        console.log(res.data)
        setFormData({
          username: res.data.username,
          email: res.data.email,
          role: res.data.role,
          permissions: res.data.permissions.join(', '),
          color: res.data.color
        });
      } catch (err) {
        setError('Failed to fetch user data');
        console.error(err);
      }
    };

    // Fetch available roles
    const fetchRoles = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRoles(res.data);
      } catch (err) {
        setError('Failed to fetch roles');
        console.error(err);
      }
    };

    fetchUserRole();
    fetchUser();
    fetchRoles();
  }, [userId, navigate]);

  const handleChange = (e) => {
    console.log(formData.color)
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      await axios.put(`${process.env.REACT_APP_URL}/users/${userId}`, {
        ...formData,
        permissions: formData.permissions.split(',').map((perm) => perm.trim()),
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to update user');
      console.error(err);
    }
  };

  if (!user) return <p>Loading...</p>;

  return (
    <div className={styles.editUser}>
      <h2>Edit User</h2>
      {error && <p className={styles.error}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          placeholder="Username"
          required
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
          <input
          className={styles.colorInput}
          type="color"
          name="color"
          value={formData.color}
          onChange={handleChange}
          placeholder="Color"
          required
        />
        <select
          name="role"
          value={formData.role}
          onChange={handleChange}
          required
        >
          <option value="">Select a role</option>
          {roles.map((role) => (
            <option key={role.name} value={role.name}>{role.name}</option>
          ))}
        </select>
        <input
          type="text"
          name="permissions"
          value={formData.permissions}
          onChange={handleChange}
          placeholder="Permissions (comma separated)"
        />
        <button type="submit">Save</button>
      </form>
    </div>
  );
};

export default EditUser;
